import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Mainheader from "./Mainheader";
import Menuheader from "./Menuheader";
import Mainpage from "./Mainpage";
import { Box } from "@mui/material";
import Configuration from "./Configuration";
import UserConfiguration from "./UserConfiguration";
import { createContext, useState } from "react";
import ReportingModule from "./ReportingModule";
import AlarmData from "./AlertsData/AlarmData";
import Auditlog from "./ConfigPages/AuditLog";
import { useDispatch} from "react-redux";
import { clearLoginData } from "../store/login_data";
import InactivityHandler from "./InactivityHandler";
import { Link, useNavigate } from "react-router-dom";
import CustomDialogBox from "./CommonComponents/CustomDialogBox";
import { useAuth0 } from "@auth0/auth0-react";
import { getGeneralConfiguration } from "../Restclient/datacollection";
import {updategeneralConfiguration} from "../store/mainpage_data";
const ThemeContext = createContext();
 
export default function Homepage() {
  const { logout } = useAuth0();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.themedata.theme);
  const selectedPage = useSelector(
    (state) => state.pageselectdata.selectedPage
  );
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [countAlarms, setCountAlarms] = useState("");
   const userinactivitytimeout = useSelector((state) => state.logindata.userinactivitytimeout)
  const[timeoutValue, setTimeoutValue] = useState(900);
  const inactivityTimeout = sessionStorage.getItem("inactivityTimeout");

  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  // const inactivityTimeout = 15 * 60 * 1000;
  // const timerRef = useRef();
  // const resetTimer = () => {
  //   clearTimeout(timerRef.current);
  //   timerRef.current = setTimeout(() => {
  //     setOpenDialog(true);
  //   }, inactivityTimeout);
  // };
  const handleInactivityTimeout = () => {
    setOpenDialog(true);
  };
  useEffect(() => {
    if(userdetails.PermissionsArray.includes("PJGC23")){
      //general config set
      getGeneralConfiguration(getgeheralconfigcallback)
    }
    // // List of events that indicate user activity
    // const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    // // Attach event listeners
    // events.forEach(event =>
    //   window.addEventListener(event, resetTimer)
    // );
    // // Start the timer initially
    // resetTimer();

    // return () => {
    //   // Clean up event listeners and timer
    //   events.forEach(event =>
    //     window.removeEventListener(event, resetTimer)
    //   );
    //   clearTimeout(timerRef.current);
    // };
  }, []);
  useEffect(() => {
    
    // Only update if we have a valid timeout value
    if (inactivityTimeout && inactivityTimeout > 0) {
      
      setTimeoutValue(inactivityTimeout);
    } else {
      console.log("Invalid timeout, keeping default:", timeoutValue, "seconds");
    }
  }, [inactivityTimeout]);
 
  const redirect = () => {
    dispatch(clearLoginData());
      sessionStorage.clear();
      localStorage.clear();
      logout({ logoutParams: { returnTo: window.location.origin } });

  }

  function getgeheralconfigcallback(res){
        if(res.request.status===200){
          const data ={
            energyBaseline : res.data.configinfo.EnergyBaseline,
            energyTarget : res.data.configinfo.EnergyYearlyTarget,
            energyMaxLimit : res.data.configinfo.EnergyMaximumLimit,
            energyPerUnitCost : res.data.configinfo.EnergyPerUnitCost,
            costBaseline : res.data.configinfo.CostBaseline,
            costTarget : res.data.configinfo.CostTarget,
            costUnit : res.data.configinfo.CostUnit,
            energyUnit : res.data.configinfo.EnergyUnit,
            energyUnitType : res.data.configinfo.EnergyTypeUnit,
            decimalPoints: res.data.configinfo.DecimalPrecision,
            alertSoundSettings:{'HighestPriority':res.data.configinfo.AlertSoundSettings.HighestPriority,'HighPriority':res.data.configinfo.AlertSoundSettings.HighPriority,'MediumPriority':res.data.configinfo.AlertSoundSettings.MediumPriority,'LowPriority':res.data.configinfo.AlertSoundSettings.LowPriority}
          }
          dispatch(updategeneralConfiguration(data));
        } else{
            //unable to fetch data
            //error
        }
    }
  // useEffect(() => {
  //   //console.log("Home page ", selectedPage)
  // }, [selectedPage]);
  return (
    <ThemeContext.Provider value={{ theme }}>
      
      <InactivityHandler timeoutKey={timeoutValue} onTimeout={handleInactivityTimeout} />

      <Box className={`${theme}`}>
        <Mainheader />
        {/* <Menuheader /> */}
        {selectedPage === "home" && <Mainpage />}
        {selectedPage === "config" && <Configuration />}
        {selectedPage === "usermanage" && <UserConfiguration />}
        {selectedPage === "reporting" && <ReportingModule />}
        {selectedPage === "alarm" && (
          <AlarmData setCountAlarms={setCountAlarms} />
        )}
        {selectedPage === "audit" && <Auditlog />}
        <CustomDialogBox
          dialogTitle={"You have been logged out due to Inactivity"}
          dialogText={"You will be redirected to login page"}
          openDialog={openDialog}
          handleConfirmDialog={redirect}
          confirmText={"OK"}
          type={"Warning"}
          align={"center"}
        />
      </Box>
    </ThemeContext.Provider>
  );
}
 
export { ThemeContext };